export const obtenerPremio = ({items=[], puntos}) =>{


    let item = false

    for (let i = 0; i < items.length; i++) {
        if (puntos > items[i].valor) {

            item = items[i]
        }
    }

    return item

}